import clsx from 'clsx';

type HeadingProps = { level?: 1 | 2 | 3 | 4 | 5 | 6 } & React.ComponentPropsWithoutRef<
  'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
>;

export function Heading({ className, level = 1, ...props }: HeadingProps) {
  const Element: `h${typeof level}` = `h${level}`;

  return (
    <Element
      {...props}
      className={clsx(
        className,
        'tw:!text-2xl/8 tw:font-semibold tw:text-zinc-900 tw:sm:!text-xl/8 tw:dark:text-zinc-100 tw:!mb-0'
      )}
    />
  );
}

export function Subheading({ className, level = 2, ...props }: HeadingProps) {
  const Element: `h${typeof level}` = `h${level}`;

  return (
    <Element
      {...props}
      className={clsx(
        className,
        'tw:!text-base/7 tw:font-semibold tw:text-zinc-900 tw:sm:!text-sm/6 tw:dark:text-zinc-100 tw:!mb-0'
      )}
    />
  );
}
